import { useSuspenseQuery } from '@tanstack/react-query'

import { GetBlocosService } from '@/features/blocos/services/get-blocos.service'
import { blocosKeys } from '@/features/blocos/utils'

export const useSuspenseBlocos = (empreendimentoId: string) => {
  return useSuspenseQuery({
    queryKey: blocosKeys.lista(empreendimentoId),
    queryFn: async () => new GetBlocosService().execute(empreendimentoId).then((res) => res.data),
  })
}
